import React, { FC } from 'react';

import { ContainerDiv } from './styles';

const Container: FC = ({ children, ...props }) => (
  <ContainerDiv {...props}>{children}</ContainerDiv>
);

export default Container;
